import { EmConstrucao } from "../../components/EmConstrucao"

export default function Categorias(){
    return(
        <div>
           <EmConstrucao/> 
        </div>
    )
}